// Daniel Jackson
// Copyright 1994 and 2021
import { Point4D } from './Point4D.js';
import { matmul } from './Matrix.js';

class HyperCube {
  constructor(n) {
    this.dimension = n;
    console.log('this.dimension', this.dimension);
    this.numberVertices = Math.pow(2, this.dimension);

    this.points = [];
    this.lines = [];
    this.polygons = [];

    //  Create Points
    for (let i = 0; i < this.numberVertices; i++) {
      let point = {};

      /* Bitwise operations */
      if (i & (1 << 0)) point.x = -1.0;
      else point.x = 1.0;
      if (i & (1 << 1)) point.y = -1.0;
      else point.y = 1.0;
      if (i & (1 << 2)) point.z = -1.0;
      else point.z = 1.0;
      if (i & (1 << 3)) point.w = -1.0;
      else point.w = 1.0;

      // this.points[i] = new Point4D(point.x, point.y, point.z, point.w);
      this.points.push([point.x, point.y, point.z, point.w]);
    }

    console.log('N-cube points = ', this.points);
    // x: 1, y: 1, z: 1, w: 1
    // x: -1, y: 1, z: 1, w: 1
    // x: 1, y: -1, z: 1, w: 1
    // x: -1, y: -1, z: 1, w: 1
    // x: 1, y: 1, z: -1, w: 1
    // x: -1, y: 1, z: -1, w: 1
    // x: 1, y: -1, z: -1, w: 1
    // x: -1, y: -1, z: -1, w: 1
    // x: 1, y: 1, z: 1, w: -1
    // x: -1, y: 1, z: 1, w: -1
    // x: 1, y: -1, z: 1, w: -1
    // x: -1, y: -1, z: 1, w: -1
    // x: 1, y: 1, z: -1, w: -1
    // x: -1, y: 1, z: -1, w: -1
    // x: 1, y: -1, z: -1, w: -1
    // x: -1, y: -1, z: -1, w: -1

    // Create Lines
    let lineIndex = 0;

    for (let i = 0; i < this.numberVertices; i++) {
      for (let j = i + 1; j < this.numberVertices; j++) {
        let test = 0;
        if (this.points[i][0] == this.points[j][0]) test += 1;
        if (this.points[i][1] == this.points[j][1]) test += 1;
        if (this.points[i][2] == this.points[j][2]) test += 1;
        if (this.points[i][3] == this.points[j][3]) test += 1;

        if (test == 3) {
          let line = [i, j];
          this.lines[lineIndex] = line;
          lineIndex += 1;
        }
      }
    }

    /* 
    Create Polygons
    I. Create index of coordinates
    II. Create list of combinations where r i.e. (n-2) are the same - combinations of size N from an array
    III. For each vertex check polygons for the list of combinations
    */

    // I. create index of coordinates
    let coordinates = [];

    for (let i = 0; i < this.dimension; i++) {
      console.log(i);
      coordinates[i] = i;
    }

    // II. Create list of combinations where r i.e. (n-2) are the same combinations of size N from an array

    // array - source list
    // length - size N form arraay
    const combine = (array, length) => {
      const c = (l, r) => {
        let ll = l.slice();
        if (r.length === length) {
          result.push(r);
          return;
        }
        while (ll.length) {
          c(ll, r.concat(ll.shift()));
        }
      };
      let result = [];
      c(array, []);
      return result;
    };
    const combinations = combine(coordinates, this.dimension - 2);

    // III. For each vertex check polygons for the list of combinations
    // For each vertex
    // for (let i = 0; i < this.points.length; i++) {

    //   // For each combination see if there is a valid polygon
    //   for (let j = 0; j < this.combinations.length; j++) {
    //     let temp = []
    //     for(let k =i+1; k < this.points.length; k++)
    //     {
    //         if(this.points[i].x == this.points)
    //     }
    //   }
    // }
    console.log('combinations', combinations);
    // Get Normals
  }

  transformUpdate(
    scale,
    xyRot,
    xzRot,
    xwRot,
    yzRot,
    ywRot,
    zwRot,
    points,
    lines
  ) {
    let positions = points.geometry.attributes.position.array;
    let linePositions = lines.geometry.attributes.position.array;
    const scale4D = [
      [scale, 0, 0, 0],
      [0, scale, 0, 0],
      [0, 0, scale, 0],
      [0, 0, 0, scale],
    ];

    const rotationXY = [
      [Math.cos(xyRot), -Math.sin(xyRot), 0, 0],
      [Math.sin(xyRot), Math.cos(xyRot), 0, 0],
      [0, 0, 1, 0],
      [0, 0, 0, 1],
    ];

    const rotationXZ = [
      [Math.cos(xzRot), 0, -Math.sin(xzRot), 0],
      [0, 1, 0, 0],
      [Math.sin(xzRot), 0, Math.cos(xzRot), 0],
      [0, 0, 0, 1],
    ];

    const rotationXW = [
      [Math.cos(xwRot), 0, 0, -Math.sin(xwRot)],
      [0, 1, 0, 0],
      [0, 0, 1, 0],
      [Math.sin(xwRot), 0, 0, Math.cos(xwRot)],
    ];

    const rotationYZ = [
      [1, 0, 0, 0],
      [0, Math.cos(yzRot), -Math.sin(yzRot), 0],
      [0, Math.sin(yzRot), Math.cos(yzRot), 0],
      [0, 0, 0, 1],
    ];

    const rotationYW = [
      [1, 0, 0, 0],
      [0, Math.cos(ywRot), 0, -Math.sin(ywRot)],
      [0, 0, 1, 0],
      [0, Math.sin(ywRot), 0, Math.cos(ywRot)],
    ];
    const rotationZW = [
      [1, 0, 0, 0],
      [0, 1, 0, 0],
      [0, 0, Math.cos(zwRot), -Math.sin(zwRot)],
      [0, 0, Math.sin(zwRot), Math.cos(zwRot)],
    ];

    const projected3d = [];
    let r = 3; // Distance to origin from viewpoint
    let f = 2; // Distance from origin to projection plane

    // Vertices
    for (let i = 0; i < this.points.length; i++) {
      const v = this.points[i];
      let transformed = matmul(scale4D, v);
      transformed = matmul(rotationXY, transformed);
      transformed = matmul(rotationXZ, transformed);
      transformed = matmul(rotationXW, transformed);
      transformed = matmul(rotationYZ, transformed);
      transformed = matmul(rotationYW, transformed);
      transformed = matmul(rotationZW, transformed);

      // let w = r - f / (r - transformed.w);

      // const projection = [
      //   [w, 0, 0, 0],
      //   [0, w, 0, 0],
      //   [0, 0, w, 0],
      // ];

      // let projected = matmul(projection, transformed);
      let newX = ((r - f) * transformed[0]) / (r - transformed[3]);
      let newY = ((r - f) * transformed[1]) / (r - transformed[3]);
      let newZ = ((r - f) * transformed[2]) / (r - transformed[3]);

      let projected = new Point4D(newX, newY, newZ, 0);

      // projected.mult(width / 4);
      projected3d[i] = projected;
      positions[i * 3] = projected3d[i].x;
      positions[i * 3 + 1] = projected3d[i].y;
      positions[i * 3 + 2] = projected3d[i].z;
    }

    points.geometry.attributes.position.needsUpdate = true;

    // Lines

    for (let i = 0; i < this.lines.length; i++) {
      // First line point vertices
      linePositions[i * 3 * 2] = projected3d[this.lines[i][0]].x;
      linePositions[i * 3 * 2 + 1] = projected3d[this.lines[i][0]].y;
      linePositions[i * 3 * 2 + 2] = projected3d[this.lines[i][0]].z;

      // First line point vertices
      linePositions[i * 3 * 2 + 3] = projected3d[this.lines[i][1]].x;
      linePositions[i * 3 * 2 + 4] = projected3d[this.lines[i][1]].y;
      linePositions[i * 3 * 2 + 5] = projected3d[this.lines[i][1]].z;
    }
    lines.geometry.attributes.position.needsUpdate = true;
  }
}

export { HyperCube };
